import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Combien d’élève-athlète les tuteurs bénévole accompagnent-ils ? ",
        answers: ["1 à 2 élèves-athlètes. ", 
            "1 élève-athlète. ", 
            "2 élèves-athlètes. "],
        correctAnswer: 0,
        explanation: "Des triades sont généralement formées, mais si un élève-athlète rencontre des difficultés d’apprentissage une dyade sera formée.  "
    },
    {
        question: "VRAI ou FAUX : Lorsqu’un élève-athlète ou un tuteur annule une séance de tutorat, celle-ci doit être reprise. ",
        answers: ["VRAI", "FAUX"],
        correctAnswer: 0,
        explanation: "VRAI. Dans la mesure du possible, lorsqu’une séance doit être annulée, il faut la reprendre. Toutefois, s’il est impossible de trouver une autre disponibilité commune, la séance sera annulée. "
    }
];

export function Step2Page() {
    return (
        <Step
            stepNumber="2"
            title="Deuxième capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video2.mp4`}
            redirectURL="/formation/3"
            questions={questions}
        />
    );
} 